<style lang="scss" scoped>
.container {
  position: relative;
}
.shipping {
  color: #606266;
}
.shipping-type-section {
}
.shipping-type-card {
  position: relative;
  display: inline-block;
  vertical-align: top;
  width: 240px;
  height: 240px;
  padding: 20px;
  margin-top: 20px;
  border: 1px solid #ccc;
  border-radius: 5px;
  text-align: center;
  i {
    font-size: 40px;
    margin-bottom: 10px;
  }
}
.shipping-type-card + .shipping-type-card {
  margin-left: 20px;
}
.shipping-title {
  font-size: 16px;
  margin-bottom: 16px;
}
.shipping-description {
  padding-left: 15px;
  position: relative;
  line-height: 18px;
}
.shipping-description:before {
  content: '';
  position: absolute;
  left: 0px;
  top: 3px;
  margin-right: 5px;
  width: 8px;
  height: 8px;
  border-radius: 100%;
  background-color: #606266;
}
.shipping-icon-unselected {
  display: inline-block !important;
  width: 40px;
  height: 40px;
  margin-bottom: 6px !important;
  background-image: url('../../../assets/img/takeout-icon-b.png');
  background-size: cover;
}
.shipping-icon-selected {
  display: inline-block !important;
  width: 40px;
  height: 40px;
  margin-bottom: 6px !important;
  background-image: url('../../../assets/img/takeout-icon.png');
  background-size: cover;
}
.shipping-icon-self-unselected {
  display: inline-block !important;
  width: 40px;
  height: 40px;
  margin-bottom: 6px !important;
  background-image: url('../../../assets/img/takeout-icon-b.png');
  background-size: cover;
}
.shipping-icon-self-selected {
  display: inline-block !important;
  width: 40px;
  height: 40px;
  margin-bottom: 6px !important;
  background-image: url('../../../assets/img/takeout-icon.png');
  background-size: cover;
}
.shipping-select-btn {
  position: absolute;
  left: 20px;
  bottom: 20px;
  width: 240px;
}
.form {
  margin: 20px 0;
}
.inline-form-item {
  width: 160px;
  margin-right: 20px;
}
.fee-desc-part {
  display: inline-block;
}
.fee-desc-part:first-child {
  width: 70px;
}
.shipping-fee-line {
  margin-bottom: 10px;
}
.save-btn-container {
  text-align: right;
}
.switch-shipping-btn {
  position: absolute;
  top: 0px;
  right: 20px;
}
.edit-info-btn {
  position: absolute;
  top: 0px;
  right: 140px;
}
.el-icon-sort {
  transform: rotate(90deg);
}
.form-item {
  width: 46%;
}
.tips {
  width: 64%;
  padding-left: 100px;
  margin-top: 0;
  line-height: 16px;
  color: #aaa;
}
.map {
  width: 75%;
  height: 350px;
  margin-left: 100px;
}
.fee-section-content {
  padding: 100px;
}
.fee-title {
  font-size: 18px;
}
.fee {
  color: #ff4f4f;
  font-size: 16px;
  line-height: 40px;
  padding-bottom: 10px;
}
.fee-number {
  font-size: 32px;
}
.fee-btn {
  float: right;
  margin-left: 20px;
  width: 100px;
}
</style>

<template>
  <div class="shipping">
    <section class="container" style="padding-left:10px;">
      <el-switch v-model="enableWxShipping" active-text="外卖微信同城配送" />
    </section>
    <section class="container" style="padding-left:10px;">
      <el-switch v-model="enableSelfShipping" active-text="外卖自配送服务" />
    </section>
    <section class="container" v-if="enableWxShipping">
      <el-select placeholder="选择同城配送门店" size="small" v-model="store.legalwechat">
        <el-option :key="item" :label="item.address" :value="item.wxstoreid" v-for="item in wxintracitylist"></el-option>
      </el-select>
    </section>
    <section class="container" v-if="enableSelfShipping">
      <el-form :model="store" label-width="100px" class="form">
        <el-row :gutter="20">
          <el-col :span="8">
            <el-form-item label="起送金额">
              <el-input v-model="store.shippingminamount" type="number">
                <template slot="append"
                  >元</template
                >
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="8">
            <el-form-item label="最大配送距离">
              <el-input v-model="store.distancelimited" type="number" placeholder="0则表示不限制">
                <template slot="append"
                  >km</template
                >
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item label="距离用时">
              <div class="shipping-fee-line" v-for="item of store.distancepricelistList" :key="item.distance">
                <span class="fee-desc-part" style="margin-right: 20px;">{{ item.distance !== 10000 ? '小于' + (item.distance + 'km') : '大于10km' }}</span>
                <span class="fee-desc-part" style="margin-right: 20px;">配送费</span>
                <el-input class="inline-form-item" v-model="item.price">
                  <template slot="append"
                    >元</template
                  >
                </el-input>
                <span class="fee-desc-part" style="margin-right: 20px;">需用时</span>
                <el-select class="inline-form-item" placeholder="请选择用时" v-model="item.duration">
                  <el-option label="15分钟" :value="900"></el-option>
                  <el-option label="30分钟" :value="1800"></el-option>
                  <el-option label="45分钟" :value="2700"></el-option>
                  <el-option label="1小时" :value="3600"></el-option>
                  <el-option label="1.5小时" :value="5400"></el-option>
                  <el-option label="2小时" :value="7200"></el-option>
                  <el-option label="3小时" :value="10800"></el-option>
                  <el-option label="1天" :value="86400"></el-option>
                </el-select>
              </div>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </section>
    <section class="container">
      <div class="save-btn-container">
        <el-button type="primary" @click="updateStore">
          保存
        </el-button>
      </div>
    </section>
  </div>
</template>

<script>
/* eslint-disable */
import { rpc } from '../../../service/index';
import { M } from '../../../service/grpc';
import { getToken } from '../../../service/helper';

const distancepricelistList = [
  {
    distance: 2,
    price: 0,
    duration: 1800
  },
  {
    distance: 5,
    price: 0,
    duration: 1800
  },
  {
    distance: 10,
    price: 0,
    duration: 7200
  },
  {
    distance: 10000,
    price: 0,
    duration: 86400
  }
];
export default {
  name: 'shipping',
  data() {
    return {
      token: getToken(),
      store: {},
      wxintracitylist: [],
      enableSelfShipping: false,
      enableWxShipping: false
    };
  },
  watch: {
    enableSelfShipping(v) {
      if(v)this.enableWxShipping=false
    },
    enableWxShipping(v) {
      if(v)this.enableSelfShipping=false
    }
  },
  mounted() {
    rpc('StoreAuthService.GetStore', M('Token', { token: this.token })).then(res => {
      res.shippingminamount = res.shippingminamount / 100;
      res.distancelimited = res.distancelimited / 1000;
      res.distancepricelistList = res.distancepricelistList.map(v => ({
        ...v,
        distance: v.distance / 1000,
        price: v.price / 100
      }));
      res.distancepricelistList = res.distancepricelistList.length ? res.distancepricelistList : distancepricelistList;
      this.store = res;
      this.enableSelfShipping = this.store.deliverkindlistList.includes(2) && this.store.shippingway == 1;
      this.enableWxShipping = this.store.deliverkindlistList.includes(2) && this.store.shippingway ==
        2;
    });
    rpc('StoreDeliveryService.GetAllWxIntracityList', M('Token', { token: this.token })).then(res => {
      this.wxintracitylist = res.wxintracitylistList;
    });
  },
  methods: {
    updateStore() {
      const params = JSON.parse(JSON.stringify(this.store));
      params.shippingminamount = parseInt(params.shippingminamount * 100);
      params.distancelimited = parseInt(params.distancelimited * 1000);
      params.distancepricelistList = params.distancepricelistList.map(v => ({
        ...v,
        distance: parseInt(v.distance * 1000),
        price: parseInt(v.price * 100)
      }));
      if (!this.enableSelfShipping && !this.enableWxShipping && params.deliverkindlistList.includes(2)) {
        params.deliverkindlistList = params.deliverkindlistList.filter(v => v !== 2);
      }
      if ((this.enableSelfShipping || this.enableWxShipping) && !params.deliverkindlistList.includes(2)) {
        params.deliverkindlistList.push(2);
      }
      if (this.enableSelfShipping){
        params.shippingway = 1;
      }
      if (this.enableWxShipping){
        params.shippingway = 2;
      }
      rpc(
        'StoreStoreService.UpdateInfo',
        M('StoreWithTokenRequest', {
          token: M('Token', { token: this.token }),
          store: M('Store', {
            ...params,
            businesshoursList: params.businesshoursList.map(v => M('BusinessHours', v)),
            distancepricelistList: params.distancepricelistList.map(v => M('DistancePrice', v))
          })
        })
      ).then(res => {
        res.shippingminamount = res.shippingminamount / 100;
        res.distancelimited = res.distancelimited / 1000;
        res.distancepricelistList = res.distancepricelistList.map(v => ({
          ...v,
          distance: v.distance / 1000,
          price: v.price / 100
        }));
        this.store = res;
      });
    }
  }
};
</script>

